import fetchMerchandiseBrands from 'actions/merchandise/fetchMerchandiseBrands'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useMemo } from 'react'
import { EmptyArray, nonNullable } from 'lib/array/arrayUtils'

interface Options {
  disabled?: boolean;
}

type ReturnType = [
  Array<App.MerchandiseBrand>,
  boolean,
  any,
]

function useMerchandiseBrands(ids: Array<string> = EmptyArray, options: Options = {}): ReturnType {
  const dispatch = useAppDispatch()

  const brandData = useAppSelector(state => state.merchandise.merchandiseBrands)

  useEffect(() => {
    if (!options.disabled) {
      dispatch(fetchMerchandiseBrands())
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options.disabled])

  const brands = useMemo(() => {
    return nonNullable(ids.map(id => brandData?.brands?.[id]))
  }, [ids, brandData])

  return [
    brands,
    brandData?.fetching ?? false,
    brandData?.error,
  ]
}

export default useMerchandiseBrands
